import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import { Observable } from "rxjs/Observable";

import * as _ from 'underscore';

// Service
import { AreaListService } from '../../service/area-list/area-list.service';

@Component({
	selector: 'app-area-list',
	templateUrl: './area-list.component.html',
	providers: [
		AreaListService,
		HttpModule
	]
})
export class AreaListComponent implements OnInit {

	private token;
	public areas: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	area: FormGroup;

	constructor(fb: FormBuilder, private areaListService: AreaListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.area = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		if(!this.permissoes['AreaIrrigada_Acesso']){
			this.router.navigateByUrl('/unauthorized/401');
		}else
			this.searchArea(this.area.value, 0, false);
		
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchArea(this.area.value, this.currentPage, false);
	}

	searchArea(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.areaListService.searchArea(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.areas = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchArea(this.area.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/area/component/area-list/area-list.component.ts